<ng-container *transloco="let t">
  <ld-base-modal
    [title]="t('modalsBankSelectionTitle')"
    [size]="'large'"
    [isLoading]="isLoading()"
    (closeModal)="onCancel()"
  >
    <div modal-content>
      <p class="font-dm font-medium text-sm text-ld-neutral-500 mb-3">
        @if (showingSearchResults()) {
          {{ t('commonBankSelectionSearchResults') }}
        } @else {
          {{ t('modalsBankSelectionPopularBanks') }}
        }
      </p>

      @if (isLoading() || isSearching()) {
        <div class="flex flex-col items-center justify-center py-12">
          <mat-spinner diameter="40" class="mb-4"></mat-spinner>
          <p class="font-dm text-sm text-ld-neutral-500">
            @if (isSearching()) {
              {{ t('commonSearching') }}
            } @else {
              {{ t('modalsBankSelectionLoadingInstitutions') }}
            }
          </p>
        </div>
      } @else if (displayedInstitutions().length === 0) {
        <div class="flex flex-col items-center justify-center py-12 text-center">
          <mat-icon class="text-ld-neutral-200 text-5xl! w-12! h-12! mb-3">account_balance</mat-icon>
          @if (showingSearchResults()) {
            <h3 class="font-dm font-semibold text-base text-ld-neutral mb-1">
              {{ t('modalsBankSelectionNoBanksFound') }}
            </h3>
            <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsBankSelectionTryDifferentSearch') }}</p>
          } @else {
            <h3 class="font-dm font-semibold text-base text-ld-neutral mb-1">
              {{ t('modalsBankSelectionNoInstitutions') }}
            </h3>
            <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsBankSelectionTryAgainLater') }}</p>
          }
        </div>
      } @else {
        <div class="grid grid-cols-2 gap-3">
          @for (institution of displayedInstitutions(); track institution.providerInstitutionId; let i = $index) {
            <button
              [id]="'bank-option-' + i"
              type="button"
              class="flex flex-col items-center gap-2 p-4 rounded-xl cursor-pointer transition-all border-2"
              [class.border-ld-primary]="selectedInstitution() === institution"
              [class.bg-ld-primary-50]="selectedInstitution() === institution"
              [class.border-ld-neutral-200]="selectedInstitution() !== institution"
              [class.hover:border-ld-neutral-300]="selectedInstitution() !== institution"
              [class.hover:bg-ld-neutral-50]="selectedInstitution() !== institution"
              (click)="selectInstitution(institution)"
              [disabled]="isLoading()"
            >
              @if (getInstitutionLogo(institution)) {
                <div class="size-12 rounded-xl flex items-center justify-center overflow-hidden shrink-0 bg-white">
                  <img
                    [src]="getInstitutionLogo(institution)"
                    [alt]="institution.name"
                    class="size-full object-contain p-1"
                  />
                </div>
              } @else {
                <div
                  class="size-12 rounded-xl flex items-center justify-center overflow-hidden shrink-0"
                  [style.background-color]="'#f3f4f6'"
                >
                  <span class="font-dm font-bold text-white text-sm">
                    {{ getInitials(institution.name) }}
                  </span>
                </div>
              }

              <p
                class="font-dm text-sm text-center leading-tight line-clamp-2"
                [class.font-semibold]="selectedInstitution() === institution"
                [class.text-ld-primary]="selectedInstitution() === institution"
                [class.text-ld-neutral]="selectedInstitution() !== institution"
              >
                {{ institution.name }}
              </p>

              @if (selectedInstitution() === institution) {
                <div class="absolute top-2 right-2 size-5 rounded-full bg-ld-primary flex items-center justify-center">
                  <mat-icon class="text-white text-sm! w-3! h-3!">check</mat-icon>
                </div>
              }
            </button>
          }
        </div>
      }
    </div>
    <div modal-footer>
      <button
        id="bank-selection-cancel-btn"
        type="button"
        class="btn-outline-ld-purple"
        [disabled]="isLoading()"
        (click)="onCancel()"
      >
        {{ t('commonButtonsCancel') }}
      </button>
      <button
        id="bank-selection-confirm-btn"
        type="button"
        class="btn-primary-ld-purple"
        [disabled]="isLoading() || !selectedInstitution()"
        (click)="onConfirm()"
      >
        @if (isLoading()) {
          <mat-spinner diameter="16" class="w-4! h-4! [&_circle]:stroke-white!"></mat-spinner>
        }
        {{ t('commonButtonsContinue') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
